import { Component, inject } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IconName } from '@app/utils/enums/icon-enum';
import { StatusModalData } from '@app/utils/interfaces/status-modal.interface';

@Component({
  selector: 'app-status-modal',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslateModule, ReactiveFormsModule, IconComponent],
  templateUrl: './status-modal.component.html',
  styleUrl: './status-modal.component.scss',
})
export class StatusModalComponent {
  private readonly dialogRef = inject(MatDialogRef<StatusModalComponent>);
  public readonly data = inject<StatusModalData>(MAT_DIALOG_DATA);

  public iconName = IconName;

  public get icon(): IconName {
    if (this.data.customIcon) {
      return this.data.customIcon;
    }
    return this.data.isSuccess ? IconName.SUCCESS : IconName.FAIL;
  }

  public onClose(): void {
    this.dialogRef.close(true);
  }
}
